import { render, staticRenderFns } from "./StoreLocatorConfigFaviconUploader.vue?vue&type=template&id=b00b51b6&scoped=true&"
import script from "./StoreLocatorConfigFaviconUploader.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorConfigFaviconUploader.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorConfigFaviconUploader.vue?vue&type=style&index=0&id=b00b51b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00b51b6",
  null
  
)

export default component.exports